import React from 'react';
import { View, StyleSheet, Image, Text, Font } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerColumn: {
        flexDirection: 'column',
        flex: 9,
    },
    image: {
        width: '130pt',
        height: '30pt',
        margin: '10px 30px 0 10px',
    },
    content: {
        flexDirection: 'row',
        marginBottom: '10',
        marginTop: '12',
    },
    dateColumn: {
        flex: 1,
        alignItems: 'flex-end',
    },
    date: {
        marginRight: 10,
        fontSize: 10,
        fontFamily: 'Roboto',
        fontWeight: 'normal',
    },
    subtitleContent: {
        flex: 5,
        alignItems: 'center',
    },
    subtitle: {
        fontSize: 12,
        fontFamily: 'Roboto',
        fontWeight: 'normal',
    },
    title: {
        fontSize: 14,
        fontWeight: 'bold',
        fontFamily: 'Roboto',
    },
    blankColumn: {
        flex: 1,
    },
});
Font.register({
    family: 'Roboto',
    fonts: [
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'normal',
        },
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'bold',
        },
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'light',
        },
    ],
});

export default function PdfHeader(props) {
    const { title, date, header } = props;

    return (
        <View {...props}>
            <View style={styles.headerColumn}>
                <Image style={styles.image} src="\images\logos\pdf-logo.png" />
            </View>
            <View style={styles.content}>
                <View style={styles.blankColumn} />
                <View style={styles.subtitleContent}>
                    <Text style={styles.subtitle}>{header}</Text>
                </View>
                <View style={styles.dateColumn}>
                    <Text style={styles.date}>{date}</Text>
                </View>
            </View>
            <View style={{ marginLeft: '10px' }}>
                <Text style={styles.title}>{title}</Text>
            </View>
        </View>
    );
}
